import DPSwitch from "framework/components/DPSwitch";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Col, Label, Row } from "reactstrap";



export const ProductDefaultLocation = ({ defaultLocations, setDefaultLocations, handleClearStatus, Disabled }) => {


    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 10;


    useEffect(() => {
        setCurrentPage(1);
    }, [handleClearStatus]);


    const updateLocationSelection = (index, checked) => {
        const updatedLocations = [...defaultLocations];
        updatedLocations[index].checked = checked;
        setDefaultLocations(updatedLocations);
    }


    const enableDisableAll = () => {

        //if is there at least one disabled location then enable all locations
        //else disable all locations except the default location
        //if there is no default location then enable all locations
        //if there is no location then enable all locations

        const isThereUnCheckedLocation = defaultLocations.some(location => !location.checked);

        const updatedLocations = [...defaultLocations];

        if (isThereUnCheckedLocation) {
            updatedLocations.forEach(location => {
                location.checked = true;
            });

        } else {
            updatedLocations.forEach(location => {

                if (!location.default) {
                    if (!location.inInventory) {
                        location.checked = false;
                    }
                }

            });
        }

        setDefaultLocations(updatedLocations);
    }


    const handlePageClick = (data) => {
        setCurrentPage(data.selected + 1);
    }


    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = defaultLocations.slice(indexOfFirstPost, indexOfLastPost);


    return (
        <div>
            <Row>
                <table>
                    <thead>
                        <tr>
                            <th style={{ width: '150px' }}>Location Code</th>
                            <th style={{ width: '150px' }}>Location Name</th>
                            <th style={{ width: '100px', cursor: 'pointer' }} onClick={enableDisableAll}>Checked</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentPosts.map((defaultLocation, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}>{defaultLocation.value}
                                        </Label>
                                    </td>
                                    <td>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}>{defaultLocation.label}
                                        </Label>
                                    </td>
                                    <td>
                                        <DPSwitch
                                            checked={defaultLocation.checked}
                                            onChange={(e) => {
                                                updateLocationSelection(defaultLocation.index, e);
                                            }}
                                            disabled={Disabled ? true : defaultLocation.default || defaultLocation.inInventory}
                                        />
                                    </td>
                                    <td>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}>{defaultLocation.default ? "Default Location" : defaultLocation.inInventory ? "Has Inventory Record" : ""}
                                        </Label>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </Row>

            <Row className="mt-1">
                <Col md="12">
                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(defaultLocations.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-center pagination-sm'}
                    />
                </Col>
            </Row>
        </div>
    );
};